export class EventComment {
  public EventCommentID: number = -1;
  public EventID: number = -1;
  public Comment: string = '';
  public DateCreated: Date = new Date();
  public UserCreated: number = -1;
  public UserDisplayName: string = '';

  constructor(values: Object = {}) {
    Object.assign(this, values);
    if ((values as any)?.DateCreated) {
      this.DateCreated = new Date((values as any).DateCreated);
    }
  }
}
